import React, { useEffect, useState } from 'react';

import { Col, Form, Input, Skeleton } from 'antd';
import { TabelaItens } from './tabela-itens';

import { useVendas } from './use-vendas';
import { AutoCompletePessoasWidget } from '@contentsys/contentsys-react-components';
import { useAxios } from '../../../hooks/use-axios';

const CarregaItensDevolucao = (props) => {


    const { vendaSelecionada, onChangeCredito } = props;
    const { idVenda, tipo } = vendaSelecionada;

    const { getVendaOuPedido } = useVendas();
    const [dadosVenda, setDadosVenda] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const {getApiEmitirNotas} = useAxios();

    const normalizaPedido = dados => {
        const itens = dados.itens.map(item => {

            const dadosItem = {
                produto: item.codigoProduto + " - " + item.descricaoProduto,
                descontos: item.totalDescontos || 0,
            }

            return Object.assign({}, item, dadosItem);
        })

        dados.itens = itens;
        return dados;
    }

    const normalizaVenda = dados => {
        const itens = dados.itens.map(item => {

            const dadosItem = {
                produto: item.codigo + " - " + item.descricao,
                descontos: item.valorDesconto || 0,
                quantidade: item.quantidadeComercial,
                valorUn: item.valorUnComercial,
                unidade: item.unidadeComercial,
                totalItem: (item.totalProduto - item.valorDesconto)
            }

            return Object.assign({}, item, dadosItem);
        });

        dados.itens = itens;
        return dados;
    }

    const normalizaDados = (dados, tipo) => {
        console.log(dados);

        if (tipo == 'Pedido') {
            return normalizaPedido(dados);
        } else {
            return normalizaVenda(dados);
        }



    }
    const carregarVenda = async () => {
        setLoading(true);
        try {
            const dados = await getVendaOuPedido(idVenda, tipo);
            setDadosVenda(normalizaDados(dados, tipo));
            setError(false);
        } catch (e) {
            console.log(e);
            setError(true);
        } finally {

            setLoading(false);


        }

    }

    useEffect(() => {
        carregarVenda(idVenda);
    }, []);

    if (error) {
        return <>Nao foi possivel carregar os dados dos itens. Tente novamente</>
    }

    console.log("dadosVenda", dadosVenda)

    return <Skeleton loading={loading}>
        <Col span={6}>
            <Form.Item id="vendedor" name="vendedor" label="Vendedor Responsável pela Devolução">
                <AutoCompletePessoasWidget tipoPessoa="VENDEDOR" getApi={getApiEmitirNotas} selectedItem={(dadosVenda?  dadosVenda.uuidVendedor || null : null)} />
            </Form.Item>

        </Col>

        <TabelaItens
            dadosVenda={dadosVenda}
            onChangeCredito={onChangeCredito}></TabelaItens>
    </Skeleton>;






}

export { CarregaItensDevolucao };